import { isEmpty } from 'ramda';

function init() {
	const swiper = document.body.querySelectorAll(".swiper-root");

	if (isEmpty(swiper)) return;

	import("~/swiper.js").then(({ initSwiper }) => {
		swiper.forEach(initSwiper);
	});
}

document.addEventListener('DOMContentLoaded', init);
